import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 区域列表
  projectArealist(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/projectArea/list',
      method: 'get',
      params: params
    })
  },
  // 危险源类型列表
  dangertypelist(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/danger/type/list',
      method: 'get',
      params: params
    })
  },
  // 危险源列表
  dangersourcelist(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/danger/source/list',
      method: 'get',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/dangerous/index.js